export {paths, demoPaths, manpowerPaths} from './paths';
